import Vue from 'vue'
import Vuex from 'vuex';
import './assets/css/h2g.scss';
import BootstrapVue from 'bootstrap-vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import App from './App.vue'
import store from './store'

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.use(BootstrapVue);

Vue.use(Vuex);

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
